import React, { useEffect } from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/24/solid';
import { isPreprodEnv } from '../utils/env';

const BANNER_HEIGHT = '3rem';

export default function PreprodBanner() {
  const visible = isPreprodEnv();

  useEffect(() => {
    if (!visible) return undefined;

    const root = document.documentElement;
    root.classList.add('is-preprod');
    root.style.setProperty('--preprod-banner-height', BANNER_HEIGHT);

    const previousTitle = document.title;
    if (!previousTitle.startsWith('[PRÉPROD]')) {
      document.title = `[PRÉPROD] ${previousTitle}`;
    }

    return () => {
      root.classList.remove('is-preprod');
      root.style.removeProperty('--preprod-banner-height');
      document.title = previousTitle;
    };
  }, [visible]);

  if (!visible) return null;

  return (
    <div
      role="status"
      className="fixed inset-x-0 top-0 z-[10000] flex h-12 items-center justify-center gap-2 bg-honey-200 px-3 py-2 text-center text-xs font-semibold text-slate-900 shadow-sm sm:text-sm"
    >
      <ExclamationTriangleIcon className="h-4 w-4 shrink-0" aria-hidden />
      <span>
        Environnement de <strong>préproduction</strong>
      </span>
    </div>
  );
}
